export const email = "nazar@bychyk.dev";
export const gitHub = "https://github.com/Ziko225";
export const instagram = "https://www.instagram.com/nazar_bychyk";
export const linkedin = "https://www.linkedin.com/in/nazarbychyk";
export const facebook = "https://www.facebook.com/Ziko255";